import { render } from "./IndexSolutionImage.vue?vue&type=template&id=4e7609e8&scoped=true"
import script from "./IndexSolutionImage.vue?vue&type=script&lang=js"
export * from "./IndexSolutionImage.vue?vue&type=script&lang=js"

import "./IndexSolutionImage.vue?vue&type=style&index=0&id=4e7609e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7609e8"]])

export default __exports__